import { c as _c } from "react/compiler-runtime";
import { RemoteIcon } from "@/components/icons/remote-icon";
import { useTRPC } from "@/lib/trpc/client";
export function Favicon(t0) {
  const $ = _c(14);
  const {
    domain,
    initialUrl,
    size: t1,
    className,
    style
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const trpc = useTRPC();
  let t2;
  if ($[0] !== domain || $[1] !== trpc.domain.getFavicon) {
    t2 = trpc.domain.getFavicon.queryOptions({
      domain
    }, {
      staleTime: Number.POSITIVE_INFINITY
    });
    $[0] = domain;
    $[1] = trpc.domain.getFavicon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    queryKey,
    queryFn
  } = t2;
  let t3;
  if ($[3] !== queryFn || $[4] !== queryKey) {
    t3 = {
      queryKey,
      queryFn
    };
    $[3] = queryFn;
    $[4] = queryKey;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${domain} icon`;
  let t5;
  if ($[6] !== className || $[7] !== domain || $[8] !== initialUrl || $[9] !== size || $[10] !== style || $[11] !== t3 || $[12] !== t4) {
    t5 = <RemoteIcon queryOptions={t3} initialUrl={initialUrl} fallbackIdentifier={domain} size={size} className={className} style={style} alt={t4} dataAttribute="data-favicon" />;
    $[6] = className;
    $[7] = domain;
    $[8] = initialUrl;
    $[9] = size;
    $[10] = style;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}